import { BlockElement } from './blocked.element';


// MenuBlockItem
export class BlockItem {
  public BlockID: string;
  public BlockType: string;
  public Code_BLO: string;
  public Name_BLO: string;
  public Info_BLO: string;
  public CidenBLO: string;
  public ParamBLO: string;
  public ElementsList: Array<BlockElement>;
}
